import { ToastProgrammatic as Toast } from 'buefy'
import api from "./api/api.js";

let ok = (message) => {
    Toast.open({message,type:'is-success', position:'is-top-right'});
}

let error = (message) => {
    Toast.open({message,type:'is-danger', position:'is-top-right',duration:5000});
}

let checkFilterLength = (filter)=> {
    return (filter && filter.length>2)
        
}

let getGamesOrder = (filter) => {
    if (filter.Timeline) {
        if (filter.Timeline == "past") return "games.end_date desc";
        if (filter.Timeline == "present") return "games.begin_date";
        if (filter.Timeline == "future") return "games.title";

    } else return "games.status_id, games.title"
}
let buildGamesFilter = (filter,lovs) => {
    let clauses = [];
 
    if (filter.Timeline) {
        clauses.push({
            "Param": "game_statuses.timeline",
            "Value": filter.Timeline
        })
    }

    if (filter.Status) {
        let statusId = lookupLOVByVal(lovs,"gameStatus",filter.Status,"GameStatus");
        if (statusId!=null) {
            clauses.push({
                "Param": "games.status_id",
                "Value": statusId.toString()
            })
        }
    }

    if (filter.Platform) {
        let platformId = lookupLOVByVal(lovs,"platform",filter.Platform,"Platform");
        if (platformId!=null) {
            clauses.push({
                "Param": "games.platform_id",
                "Value": platformId.toString()
            })
        }
    }

    if (filter.FullTitle) {
        clauses.push({
            "Param": "games.title",
            "Value": "%"+filter.FullTitle+"%"
        })
    }
    if (filter.OriginalTitle) {
        clauses.push({
            "Param": "games.original_title",
            "Value": "%"+filter.OriginalTitle+"%"
        })
    }
   
    if (filter.Id) {
        clauses.push({
            "Param": "games.id",
            "Value": filter.Id.toString()
        })
    }
    if (filter.StatusId) {
        clauses.push({
            "Param": "games.status_id",
            "Value": filter.StatusId.toString()
        })
    }
    if (filter.Dicks) {
        let x= parseFloat(filter.Dicks);
        if (!isNaN(x))
        clauses.push({
            "Param": "games.dicks",
            "Value": x.toString()
        })
    }
    if (filter.PlatformId) {
        clauses.push({
            "Param": "games.platform_id",
            "Value": filter.PlatformId.toString()
        })
    }
    
    if (filter.PurchaseYear) {
        clauses.push({
            "Param": "games.purchaseYear",
            "Value": filter.PurchaseYear.toString()
        })
    }
    if (filter.PlayDateRange) {
        clauses.push({
            "Param": "games.dateRange",
            "Value":  (Date.parse(filter.PlayDateRange)/1000).toString()
        })
    }

    if (filter.Comment) {
        clauses.push({
            "Param": "games.comment",
            "Value": "%"+filter.Comment+"%"
        })
    }

    return {Clauses:clauses,Friends:[],Tags:[]}
}

let buildSeriesFilter = (filter, lovs) => {
    let newFilter = [];
    
    if (filter.Status) {
        let statusId = lookupLOVByVal(lovs,"seriesStatusForSeasons",filter.Status,"SeriesStatus");
        if (statusId!=null) {
            newFilter.push({
                "Param": "seasons.status_id",
                "Value": statusId.toString()
            })
        }
    }
    if (filter.SeriesStatus) {
        let statusId = lookupLOVByVal(lovs,"seriesStatusForSeries",filter.SeriesStatus,"SeriesStatus");
        if (statusId!=null) {
            newFilter.push({
                "Param": "series.status_id",
                "Value": statusId.toString()
            })
        }
    }
    if (checkFilterLength(filter.SeriesTitle)) {
        newFilter.push({
            "Param": "series.title",
            "Value": "%"+filter.SeriesTitle+"%"
        })
    }
    if (checkFilterLength(filter.SeriesFullTitle)) {
        newFilter.push({
            "Param": "series.title",
            "Value": "%"+filter.SeriesFullTitle+"%"
        })
    }
    if (filter.SeriesOriginalTitle) {
        newFilter.push({
            "Param": "series.original_title",
            "Value": "%"+filter.SeriesOriginalTitle+"%"
        })
    }
    if (filter.Comment) {
        newFilter.push({
            "Param": "seasons.comment",
            "Value": "%"+filter.Comment+"%"
        })
    }
    if (filter.Id) {
        newFilter.push({
            "Param": "series.id",
            "Value": filter.Id.toString()
        })
    }
    if (filter.Number) {
        newFilter.push({
            "Param": "seasons.number",
            "Value": filter.Number.toString()
        })
    }
    if (filter.Dicks) {
        let x= parseFloat(filter.Dicks);
        if (!isNaN(x))
        newFilter.push({
            "Param": "seasons.dicks",
            "Value": x.toString()
        })
    }
    if (filter.StatusId) {
        newFilter.push({
            "Param": "seasons.status_id",
            "Value": filter.StatusId.toString()
        })
    }
    if (filter.SeriesStatusId) {
        newFilter.push({
            "Param": "series.status_id",
            "Value": filter.SeriesStatusId.toString()
        })
    }
    if (filter.ServiceId) {
        newFilter.push({
            "Param": "seasons.service_id",
            "Value": filter.ServiceId.toString()
        })
    }
    if (filter.SeriesYearBegin) {
        newFilter.push({
            "Param": "series.year_begin",
            "Value": filter.SeriesYearBegin.toString()
        })
    }
    if (filter.SeriesYearEnd) {
        newFilter.push({
            "Param": "series.year_end",
            "Value": filter.SeriesYearEnd.toString()
        })
    }
    if (filter.DateBegin) {
        newFilter.push({
            "Param": "seasons.date_begin",
            "Value":  (Date.parse(filter.DateBegin)/1000).toString()
        })
    }
    if (filter.DateEnd) {
        newFilter.push({
            "Param": "seasons.date_end",
            "Value":  (Date.parse(filter.DateEnd)/1000).toString()
        })
    }
    if (filter.DateBeginDate) {
        let ticks = Date.parse(filter.DateBeginDate);
        if (!isNaN(ticks) && ticks>0 && ticks>1000000000000 && ticks<2000000000000) {
            newFilter.push({
                "Param": "seasons.date_begin",
                "Value":  (ticks/1000).toString()
            })
        }
       
    }
    if (filter.DateEndDate) {
        let ticks = Date.parse(filter.DateEndDate);
        if (!isNaN(ticks) && ticks>0 && ticks>1000000000000 && ticks<2000000000000) {
            newFilter.push({
                "Param": "seasons.date_end",
                "Value":  (ticks/1000).toString()
            })
        }
       
    }
    
    return {Clauses:newFilter,Friends:[],Tags:[]}
}



let hasFilterChanged = (oldFilter, filter)=> {
    for (var f in filter) {
        if (filter[f] != oldFilter[f])
            return true;
    }
    return false;
}

let buildFilter = (filter) => {
    let clauses = [];
    let friends = [];

    if (filter.Title) {
        clauses.push({
            "Param": "movies.title",
            "Value": "%"+filter.Title+"%"
        })
    }
    if (filter.OriginalTitle) {
        clauses.push({
            "Param": "movies.original_title",
            "Value": "%"+filter.OriginalTitle+"%"
        })
    }
    if (filter.Full_title) {
        clauses.push({
            "Param": "movies.title",
            "Value": "%"+filter.Full_title+"%"
        })
    }
    if (filter.Id) {
        clauses.push({
            "Param": "shows.id",
            "Value": filter.Id.toString()
        })
    }
    if (filter.City_id) {
        clauses.push({
            "Param": "shows.city_id",
            "Value": filter.City_id.toString()
        })
    }
    if (filter.Dicks) {
        let x= parseFloat(filter.Dicks);
        if (!isNaN(x))
        clauses.push({
            "Param": "shows.dicks",
            "Value": x.toString()
        })
    }
    if (filter.Mode_id) {
        clauses.push({
            "Param": "shows.mode_id",
            "Value": filter.Mode_id.toString()
        })
    }
    if (filter.Service_id) {
        clauses.push({
            "Param": "shows.service_id",
            "Value": filter.Service_id.toString()
        })
    }
    if (filter.Language_id) {
        clauses.push({
            "Param": "shows.language_id",
            "Value": filter.Language_id.toString()
        })
    }
    if (filter.Year) {
        clauses.push({
            "Param": "movies.year",
            "Value": filter.Year.toString()
        })
    }
    if (filter.DateStart) {
        clauses.push({
            "Param": "shows.dateStart",
            "Value":  (Date.parse(filter.DateStart)/1000).toString()
        })
    }
    if (filter.DateEnd) {
        clauses.push({
            "Param": "shows.dateEnd",
            "Value": (Date.parse(filter.DateEnd)/1000).toString()
        })
    }
    if (filter.Friends) {
        friends = filter.Friends.map((x)=>{return x.Id});
    }
    return {Clauses:clauses,Friends:friends, Tags:[]}
}

let flattenVisions = (visions,lovs) => {
    let fullMode = (vision, lovs, isSimple) => {
        let mode = lookupLOV(lovs,"modes",vision.Ext_show.Mode_id,"Mode");
        let city = lookupLOV(lovs,"cities",vision.Ext_show.City_id,"City");
        let service_name = lookupLOV(lovs,"services",vision.Ext_show.Service_id,"Name");
        let service_room = lookupLOV(lovs,"services",vision.Ext_show.Service_id,"Room");
        let str = "";
        if (isSimple) {
            if (service_name) {
                str = `${service_name}${service_room?' '+service_room:''}` 
            } else
                str = mode;
            str += ", " + city + " - ";
            }
            
        else {
            if (mode=="Service") {
                str = "al service " + `${service_name} ${service_room?service_room:''}` 
            } else if (mode=="Streaming") {
                str = "in streaming" +  `${service_name?" su " + service_name:''}`;
            } else 
                str = "in " + mode;
            str += ", a " + city + " in ";
        }
           
        str += lookupLOV(lovs,"languages",vision.Ext_show.Language_id,"Language");
        return str; 

    };
    let fullTitle = (vision) => {
        let or_title = vision.Ext_show.Movie_original_title == vision.Ext_show.Movie_title?"id.":vision.Ext_show.Movie_original_title;
        let title = `${vision.Ext_show.Movie_title} (${or_title},${vision.Ext_show.Movie_year})`;
        if (vision.Directors.length == 0) return title;
        title = `${title} di ${vision.Directors[0].Name}`;
        if (vision.Directors.length>1) 
            title += " etc.";
        return title;
    }
    let out = [];
    
    visions.forEach(vision=>{
        out.push({
            ...vision,
            Id: vision.Ext_show.Id,
            Full_title : fullTitle(vision),
            Date_seen: buildDate(vision.Ext_show.Date_seen),
            Dicks: vision.Ext_show.Dicks,
            Quality:vision.Ext_show.Quality,
            Comment: vision.Ext_show.Comment,
            Full_mode: fullMode(vision, lovs, true),
            Full_mode_desc: fullMode(vision, lovs, false),
        });
    })
    return out;
}

let lookupLOV = (lovs,type,val,column) => {
    if (!val)
     return "";
    let lov = lovs[type];
    if (!lov)
        return "-"
    let item = lov.filter((x)=>{return x.Id==val});
    if (item.length>0) return item[0][column]; else return "-";
}

let lookupLOVByVal = (lovs,type,val,column) => {
    if (!val)
     return null;
    let lov = lovs[type];
    
    if (!lov)
        return null;
    let item = lov.filter((x)=>{return x[column].toUpperCase().indexOf(val.toUpperCase())>-1});
    
    if (item.length==1) return item[0].Id; else return null;
}


let adjLov= (lovs,lovType,id,column,store) => {
    let c = lookupLOV(lovs,lovType,id,column);
    if (c=="-") {
      let newC = store.filter(x=>{return x.Id == id});
      lovs[lovType].push(newC[0])
    }
}

let buildDate = (secs) => {
    let microFormat = (x) => {
        if (x<10)
            return "0"+x;
        else 
            return x.toString()
    }
    let d = new Date(secs*1000);
    return `${d.getFullYear()}-${microFormat(d.getMonth()+1)}-${microFormat(d.getDate())}`;
}

let buildIsoDate = (date) => {
    if (!date)
        return null;
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; 
    return (new Date(date - tzoffset)).toISOString().substring(0,10)
}

let getLovs = () => {
    let data = {};
    return new Promise((resolve, reject) => {
        api.mode.getAll()
        .then( (modes)=> {
            data.modes = modes.data;
            return api.city.getAll()
        })
        .then( (cities)=> {
            data.cities = cities.data;
            return api.friend.getAll()
        })
        .then( (friends)=> {
            data.friends = friends.data;
            return api.language.getAll()
        })
        .then( (languages)=> {
            data.languages = languages.data;
            return api.service.getAll()
        })
        .then( (services)=> {
            data.services = services.data;
            resolve(data);
        })
        .catch ((err)=>{
            reject(err);
        })
    })
}

export default {
    ok,
    error,
    flattenVisions,
    lookupLOV,
    lookupLOVByVal,
    adjLov,
    buildDate,
    buildFilter,
    buildSeriesFilter,
    buildGamesFilter,
    buildIsoDate,
    getGamesOrder,
    getLovs,
    hasFilterChanged
}